export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
export const GET_DATA_ERROR = 'GET_DATA_ERROR';
export const GET_DATA_REQUEST = 'GET_DATA_REQUEST';


// Action creators return a consistent "command" object.
export const getRequestData = () => ({
    type: GET_DATA_REQUEST
  });

export const getSuccessData= (daily_profit) => {
  return {
    type: GET_DATA_SUCCESS,
    daily_profit
  };
};



export const getDataProfit = (daily_profit_data) => async dispatch => {
  console.log('daily profit', daily_profit_data)

  if ((daily_profit_data).length !== 0) {

      dispatch(getSuccessData(JSON.stringify(daily_profit_data) ));  
  }
}

